import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosPontosEmbarque from './FiltrosAdicionadosPontosEmbarque'
import FiltroPontosEmbarque from './FiltroPontosEmbarque'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroPontosEmbarque = () => (
  <Filtro PainelFiltro={FiltroPontosEmbarque} />
)

const PainelFiltrosPontosEmbarque = () => (
  <PainelFiltragem
    Filtro={PainelFiltroPontosEmbarque}
    FiltrosAdicionados={FiltrosAdicionadosPontosEmbarque}
  />
)

export default PainelFiltrosPontosEmbarque
